document.documentElement.classList.remove('no-js');
const geoLocalizationForm = document.getElementById('GeoLocalization');
if (geoLocalizationForm) {
  const countryCode = (document.body.dataset.countryCode || '').toUpperCase();
  const currentLocale = (document.body.dataset.localeCode || '').toLowerCase();
  const availableLocales = (document.body.dataset.availableLocales || '').toLowerCase().split(',').filter(Boolean);
  const savedLocale = (localStorage.getItem('moova_language_preference_v2') || '').toLowerCase();
  const automaticLocale = countryCode === 'LT' ? 'lt' : 'en';
  const desiredLocale = availableLocales.includes(savedLocale) ? savedLocale : automaticLocale;
  const redirectKey = `moova_geo_locale_${desiredLocale}`;
  if (availableLocales.includes(desiredLocale) && currentLocale !== desiredLocale && sessionStorage.getItem(redirectKey) !== '1') {
    sessionStorage.setItem(redirectKey, '1');
    geoLocalizationForm.querySelector('[data-geo-locale-input]').value = desiredLocale;
    geoLocalizationForm.submit();
  }
}
const revealSelectors = [
  '.benefit-card',
  '.resistance-grid > *',
  '.section-heading > *',
  '.inside-grid > *',
  '.use-cases-content > .eyebrow',
  '.use-cases-content > h2',
  '.training-copy',
  '.buy-section > *',
  '.faq > *',
  '.footer-grid > *'
];
document.querySelectorAll(revealSelectors.join(',')).forEach((item, index) => {
  item.classList.add('reveal');
  item.style.setProperty('--reveal-delay', `${(index % 3) * 90}ms`);
});
const items = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  items.forEach((item) => observer.observe(item));
} else { items.forEach((item) => item.classList.add('is-visible')); }
document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
  button.addEventListener('click', () => {
    const api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.showPreferences === 'function') api.showPreferences();
    else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
  });
});
const headerSection = document.getElementById('shopify-section-header');
if (headerSection) {
  const updateHeader = () => headerSection.classList.toggle('is-scrolled', window.scrollY > 40);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

document.querySelectorAll('[data-quantity-control]').forEach((control) => {
  const input = control.querySelector('[data-quantity-input]');
  const form = control.closest('form');
  const updateButton = form && form.querySelector('[name="update"]');
  let updateTimer;
  const updateCart = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(() => {
      if (form && updateButton) form.requestSubmit(updateButton);
    }, 420);
  };
  control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    input.value = Math.max(0, Number(input.value || 0) - 1);
    updateCart();
  });
  control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    input.value = Number(input.value || 0) + 1;
    updateCart();
  });
  input?.addEventListener('change', updateCart);
});

document.querySelectorAll('[data-parcel-picker]').forEach((picker) => {
  const source = window.MOOVA_PARCEL_LOCKERS || {};
  const form = picker.closest('form');
  const carrierSelect = picker.querySelector('[data-parcel-carrier]');
  const searchInput = picker.querySelector('[data-parcel-search]');
  const lockerFields = picker.querySelector('[data-parcel-locker-fields]');
  const courierNote = picker.querySelector('[data-parcel-courier-note]');
  const results = picker.querySelector('[data-parcel-results]');
  const selection = picker.querySelector('[data-parcel-selection]');
  const selectionText = picker.querySelector('[data-parcel-selection-text]');
  const error = picker.querySelector('[data-parcel-error]');
  const carrierValue = picker.querySelector('[data-parcel-carrier-value]');
  const lockerValue = picker.querySelector('[data-parcel-locker-value]');
  const lockerId = picker.querySelector('[data-parcel-locker-id]');
  const checkoutButton = form && form.querySelector('[data-cart-checkout]');
  let currentMatches = [];

  const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const carrierName = (value) => value === 'omniva' ? 'Omniva' : value === 'dpd' ? 'DPD' : value === 'lpexpress' ? 'LP Express' : value === 'courier' ? 'International courier' : '';
  const isCourier = () => carrierSelect.value === 'courier';
  const clearSelection = () => {
    carrierValue.value = carrierName(carrierSelect.value);
    lockerValue.value = '';
    lockerId.value = '';
    selection.hidden = true;
    selectionText.textContent = '';
  };
  const closeResults = () => {
    results.hidden = true;
    searchInput.setAttribute('aria-expanded', 'false');
  };
  const showError = (message) => {
    error.textContent = message;
    error.hidden = false;
  };
  const clearError = () => {
    error.textContent = '';
    error.hidden = true;
  };
  const selectLocker = (locker) => {
    const fullLabel = `${carrierName(carrierSelect.value)} — ${locker.city}, ${locker.address} — ${locker.name}`;
    carrierValue.value = carrierName(carrierSelect.value);
    lockerValue.value = fullLabel;
    lockerId.value = locker.id;
    searchInput.value = `${locker.city}, ${locker.address}`;
    selectionText.textContent = fullLabel;
    selection.hidden = false;
    clearError();
    closeResults();
  };
  const renderResults = () => {
    const carrier = carrierSelect.value;
    const query = normalize(searchInput.value.trim());
    if (!carrier || isCourier()) {
      currentMatches = [];
      closeResults();
      return;
    }
    const lockers = Array.isArray(source[carrier]) ? source[carrier] : [];
    currentMatches = lockers.filter((locker) => {
      if (!query) return true;
      return normalize(`${locker.city} ${locker.address} ${locker.name} ${locker.id}`).includes(query);
    }).slice(0, 60);
    results.innerHTML = '';
    if (!currentMatches.length) {
      const empty = document.createElement('p');
      empty.className = 'parcel-picker__empty';
      empty.textContent = picker.dataset.emptyMessage;
      results.appendChild(empty);
    } else {
      currentMatches.forEach((locker) => {
        const button = document.createElement('button');
        const address = document.createElement('strong');
        const name = document.createElement('span');
        button.type = 'button';
        button.className = 'parcel-picker__result';
        address.textContent = `${locker.city}, ${locker.address}`;
        name.textContent = locker.name;
        button.append(address, name);
        button.addEventListener('click', () => selectLocker(locker));
        results.appendChild(button);
      });
    }
    results.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
  };

  carrierSelect.addEventListener('change', () => {
    clearSelection();
    searchInput.value = '';
    lockerFields.hidden = isCourier();
    courierNote.hidden = !isCourier();
    searchInput.disabled = !carrierSelect.value || isCourier();
    clearError();
    if (carrierSelect.value && !isCourier()) renderResults(); else closeResults();
  });
  lockerFields.hidden = isCourier();
  courierNote.hidden = !isCourier();
  searchInput.disabled = !carrierSelect.value || isCourier();
  if (isCourier()) {
    carrierValue.value = carrierName(carrierSelect.value);
    lockerValue.value = '';
    lockerId.value = '';
    selection.hidden = true;
  }
  searchInput.addEventListener('focus', renderResults);
  searchInput.addEventListener('input', () => {
    clearSelection();
    renderResults();
  });
  document.addEventListener('click', (event) => {
    if (!picker.contains(event.target)) closeResults();
  });
  checkoutButton?.addEventListener('click', (event) => {
    const missingDelivery = !carrierSelect.value || (!isCourier() && (!lockerValue.value || !lockerId.value));
    if (missingDelivery) {
      event.preventDefault();
      showError(picker.dataset.requiredMessage);
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!carrierSelect.value) carrierSelect.focus(); else searchInput.focus();
    }
  });
});

document.querySelectorAll('[data-demo-video]').forEach((video) => {
  video.addEventListener('timeupdate', () => {
    if (video.currentTime >= 30) {
      video.pause();
      video.currentTime = 0;
    }
  });
});

document.querySelectorAll('[data-exercise-open]').forEach((button) => {
  button.addEventListener('click', () => {
    const modal = document.getElementById(button.dataset.exerciseOpen);
    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
      const video = modal.querySelector('video');
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.currentTime = 0;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      }
    }
  });
});
document.querySelectorAll('.exercise-modal').forEach((modal) => {
  modal.querySelectorAll('video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.addEventListener('volumechange', () => {
      if (!video.muted) video.muted = true;
    });
  });
  const closeModal = () => {
    modal.querySelectorAll('video').forEach((video) => video.pause());
    modal.close();
  };
  modal.querySelector('[data-exercise-close]')?.addEventListener('click', closeModal);
  modal.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
  modal.addEventListener('cancel', () => modal.querySelectorAll('video').forEach((video) => video.pause()));
});
